import type { Router } from 'vue-router'

export function setupSwUpdate (router: Router) {
  if (!navigator.serviceWorker) {
    return
  }

  let swUpdated = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    swUpdated = true
  })

  router.beforeEach((to) => {
    if (swUpdated) {
      window.location.href = to.fullPath
      return false
    }
  })
}
